import { useCenterType } from '@app/store';
import { CenterTypes } from '@constants';
import { Button, ButtonTypes } from '@leegality/leegality-react-component-library';
import PropTypes from 'prop-types';
import React from 'react';

const SuccessContent = ({ trackingId, isOTNAccepted }) => {
  const centerType = useCenterType();

  const getMessage = () => {
    if (isOTNAccepted) {
      return 'Notice Accepted';
    }

    if (centerType === CenterTypes.REQUEST_CENTER) {
      return 'Request Raised Succesfully';
    }

    return 'Consent Collected Succesfully!';
  };

  return (
    <div className="flex flex-col items-center justify-center gap-6">
      <p className="text-lg font-semibold text-success-700">{getMessage()}</p>
      {trackingId && (
        <>
          <p className="mb-2 text-base font-semibold">
            {`TrackingId: ${trackingId}`}
          </p>
          {centerType === CenterTypes.REQUEST_CENTER && (
          <Button
            label="Raise Another Request"
            type={ButtonTypes.PRIMARY_OUTLINED}
            onClick={() => window.location.reload()}
          />
          )}
        </>
      )}
    </div>
  );
};

SuccessContent.defaultProps = {
  isOTNAccepted: false,
  trackingId: '',
};

SuccessContent.propTypes = {
  isOTNAccepted: PropTypes.bool,
  trackingId: PropTypes.string,
};

export default SuccessContent;
